const EMAIL_RE = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
const PASSWORD_RE = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9]{8,16}$/

export function isValidEmail(email: string): boolean {
  return EMAIL_RE.test(email)
}

export function isValidPassword(password: string): boolean {
  return PASSWORD_RE.test(password)
}
